import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { fallback } from "@tanstack/zod-adapter";
import { Suspense } from "react";
import { z } from "zod";
import { PROJECT } from "@/app/capabilities/permissions";
import { PlaygroundExecuteToolSkeleton } from "@/app/playground/execute/components/skeletons";
import { PlaygroundExecuteTool } from "@/app/playground/execute/execute";
import { requireProjectPermission } from "@/lib/route-guards";

const defaultToolId = "Github.SetStarred";
const defaultInput = {
  owner: "arcadeai",
  name: "arcade-mcp",
  starred: "true",
};

const executeSearchSchema = z.object({
  toolId: fallback(z.string().catch(""), defaultToolId).default(defaultToolId),
  input: fallback(
    z.record(z.string(), z.string()).catch({}),
    defaultInput
  ).default(defaultInput),
});

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/playground/execute"
)({
  validateSearch: executeSearchSchema,
  search: {
    middlewares: [
      stripSearchParams({ toolId: defaultToolId, input: defaultInput }),
    ],
  },
  component: () => (
    <Suspense fallback={<PlaygroundExecuteToolSkeleton />}>
      <PlaygroundExecuteTool />
    </Suspense>
  ),
  beforeLoad: (ctx) => requireProjectPermission(ctx, PROJECT.tools.execute),
  loader: () => ({
    crumb: "Execute Tool",
  }),
});
